import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'app-chart-rating-pm',
    templateUrl: './chart-rating-pm.component.html',
    styleUrls: ['./chart-rating-pm.component.css']
})
export class ChartRatingsPerMonthComponent implements OnInit {
    @Input() ratingsPerMonth: any[];
    @ViewChild('chartRatingContainer') chartRatingContainer: ElementRef;

    view: any[] = [260, 180];

    // options
    showXAxis: boolean = true;
    showYAxis: boolean = false;
    gradient: boolean = false;
    showLegend: boolean = false;
    showXAxisLabel: boolean = false;
    showGridLines: boolean = true;
    xAxisLabel: string = 'Months';
    showYAxisLabel: boolean = false;
    yAxisLabel: string = 'Audits';
    animations: boolean = true;
    rotateXAxisTicks: boolean = false;
    maxXAxisTickLength: number = 1;
    trimXAxisTicks: boolean = true;

    colorScheme = {
        domain: ['#28a745', '#ffc107', '#dc3545']
    };

    constructor() {
    }

    ngOnInit() {
        // Use setTimeout to allow the view to be rendered before setting the width of the chart
        setTimeout(() => this.view = [this.chartRatingContainer.nativeElement.offsetWidth, 180]);

        //let valueSum = 0;
        //let count = 0;
        //const len = this.daysToComplete.length;
        //let item = null;
        //for (let i = 0; i < len; i++) {
        //    item = this.daysToComplete[i];
        //    valueSum = Number(item.name) + valueSum;
        //    count = count + item.value;
        //}

        //this.avDaysToComplete = valueSum / count;
    }
}
